




import { createApp } from 'mediaEditorApp/vue3'
import Modal from 'mediaEditorApp/editor';
import { useEmitter } from '../../composition/useEmitter'
import { defineComponent } from '@vue/composition-api'
import { useAppContext } from '../../composition/useAppContext'
import { trackPendoEvent } from '../../../util/helper'

let mediaEditorModalComponent: any = {}

export default defineComponent({
watch: {
'$route': function (id) {
  this.mountMediaEditorAppModal()
},
},
mounted() {
this.mountMediaEditorAppModal()
},
methods: {
async mountMediaEditorAppModal() {
  if (mediaEditorModalComponent.unmount) mediaEditorModalComponent?.unmount()
  const route = this.$route
  const router = this.$router
  const emitter = useEmitter()
  let locale = 'en-US'

  try {
    locale = localStorage.getItem('locale') as string || 'en-US'
  } catch (error) {
    locale = 'en-US'
  }


  const { mountAppContext } = useAppContext()
  mediaEditorModalComponent = createApp(Modal, {
    route,
    router,
    emitter,
    locale,
  });
  mountAppContext({ mediaEditorApp: mediaEditorModalComponent }) 
  mediaEditorModalComponent.mount(`#media-editor-modals`);
  emitter.on('pendo-track-event', (pendoData: any)=> {
    if (pendoData?.event) trackPendoEvent(pendoData?.event, pendoData?.properties)
  });
},
}
})
